module.exports = __webpack_public_path__ + "assets/img/main-logo-handan.415e3ee8.png";